import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesSkills = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-skills-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        Vous pouvez apprendre des <span className='text-pborange'>Capacités et des Compétences </span>{' '}
                        en remplissant les conditions nécessaires pour les obtenir, puis en les sélectionnant sur
                        l'écran « <span className='text-pborange'>Apprentissage de Capacités</span> ».
                    </p>{' '}
                    <br />
                    <p>
                        Les Capacités sont des actions qui peuvent être utilisées en combat, comme les attaques, les
                        soins ou les attributions d'état. Certaines peuvent infliger d'énormes dégâts à un seul ennemi,
                        d'autres infliger des dégâts à plusieurs ennemis situés dans une vaste zone, d'autres encore
                        soigner plusieurs alliés, etc. Choisissez soigneusement vos Capacités pour tenter de renverser
                        le cours de la bataille !
                    </p>{' '}
                    <br />
                    <p>
                        Les Compétences, liées à la classe ou à l'espèce d'une unité, peuvent avoir divers effets, comme
                        augmenter les statistiques, pousser les ennemis hors de la carte, réduire les dégâts subis,
                        renforcer les Gadgets, augmenter la portée des attaques, et bien d'autres encore. Prenez votre
                        temps et amusez-vous à chercher la bonne combinaison de Compétences pour aborder vos batailles
                        en toute sérénité !
                    </p>{' '}
                    <br />
                    <p>
                        Cependant, il y a une limite à ce que vous pouvez apprendre. Voilà pourquoi il peut parfois se
                        révéler nécessaire d'oublier des Compétences et Capacités précédemment apprises. Une fois une
                        Capacité apprise, elle peut être oubliée grâce à la commande « Classer Capa. ». Les Capacités
                        oubliées peuvent être réapprises à tout moment.
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'skills',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    ) 
}
